/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateEmailSignatureDto
 */
export interface CreateEmailSignatureDto {
    /**
     * The label in the list, e.g. \"Erik – Support (EN)\". Not printed in the signature.
     * @type {string}
     * @memberof CreateEmailSignatureDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailSignatureDto
     */
    'fullName': string;
    /**
     * Empty = no job title line.
     * @type {string}
     * @memberof CreateEmailSignatureDto
     */
    'jobTitle': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailSignatureDto
     */
    'email': string;
    /**
     * As the operator writes it; dialled in E.164. A national number is read as German. Empty = no row.
     * @type {string}
     * @memberof CreateEmailSignatureDto
     */
    'phone': string;
    /**
     * Same rules as phone. Empty = no row.
     * @type {string}
     * @memberof CreateEmailSignatureDto
     */
    'mobile': string;
    /**
     * Absolute HTTPS URL of a square portrait; replaces the logo. Empty = the logo (or none).
     * @type {string}
     * @memberof CreateEmailSignatureDto
     */
    'photoUrl': string;
    /**
     * The signature\'s language (labels, legal block) — not the operator\'s UI language.
     * @type {string}
     * @memberof CreateEmailSignatureDto
     */
    'locale': CreateEmailSignatureDtoLocaleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmailSignatureDto
     */
    'showLogo': boolean;
    /**
     * Legal name, address, representatives and USt-IdNr. from COMPANY_IDENTITY.
     * @type {boolean}
     * @memberof CreateEmailSignatureDto
     */
    'showLegal': boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateEmailSignatureDtoLocaleEnum {
    De = 'de',
    En = 'en'
}


